import React from 'react';
import Icon from '../../../components/AppIcon';

const UserJourneyFlow = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No user journey data available
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {data?.map((step, index) => {
        const isLastStep = index === data?.length - 1;
        const retentionRate = ((step?.users / data?.[0]?.users) * 100)?.toFixed(1);

        return (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                  <span className="text-sm font-bold text-primary">{index + 1}</span>
                </div>
                <div>
                  <p className="font-medium text-foreground">{step?.step}</p>
                  {!isLastStep && (
                    <p className="text-xs text-muted-foreground">Next: {step?.nextStep}</p>
                  )}
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-foreground">{step?.users?.toLocaleString()}</p>
                <p className="text-xs text-muted-foreground">{retentionRate}% retained</p>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="relative h-8 bg-muted/30 rounded-lg overflow-hidden">
              <div
                className="h-full bg-primary flex items-center justify-end pr-3 transition-all duration-500"
                style={{ width: `${retentionRate}%` }}
              >
                {retentionRate > 20 && (
                  <span className="text-xs font-medium text-white">{retentionRate}%</span>
                )}
              </div>
            </div>

            {/* Drop-off Indicator */}
            {!isLastStep && step?.dropOff > 0 && (
              <div className="flex items-center gap-2 ml-11">
                <Icon name="AlertCircle" size={14} className="text-error" />
                <span className="text-xs text-error font-medium">
                  {step?.dropOff}% drop-off to next step
                </span>
              </div>
            )}

            {/* Connector Arrow */}
            {!isLastStep && (
              <div className="flex justify-center">
                <Icon name="ArrowDown" size={20} className="text-muted-foreground" />
              </div>
            )}
          </div>
        );
      })}
      {/* Summary */}
      <div className="mt-6 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Started Journey</p>
            <p className="text-lg font-bold text-foreground">{data?.[0]?.users?.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Completed Journey</p>
            <p className="text-lg font-bold text-success">{data?.[data?.length - 1]?.users?.toLocaleString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserJourneyFlow;